import { useEffect, useState } from "react";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import { globalVariables } from "helper/globalVariables";
import { debounce } from "lodash";
import { globalClasses } from "helper/globalClasses";
import { useLazyQuery } from "@apollo/client";
import { GetTrailCalenderByAuthId } from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import SearchBar from "shared/Components/search";
import { useParams } from "react-router-dom";
import { TrailListMobileHost } from "./TrailListMobileTableHost";

const headData = [
  globalVariables.name,
  globalVariables.date,
  globalVariables.location,
  globalVariables.level,
  globalVariables.noOfEntries,
  globalVariables.status,
];

const HostCalender = ({ role }) => {
  const { id } = useParams();
  const [search, setSearch] = useState("");

  const { tableDataCls } = globalClasses;

  const [
    getTrailCalender,
    { data: TrailCalenderData, loading: trailCalenderLoading },
  ] = useLazyQuery(GetTrailCalenderByAuthId);

  const TrailCalenderList =
    TrailCalenderData?.getTrialCalendarByAuthId?.data ?? [];
  useEffect(() => {
    handlePaginationData();
  }, []);

  const onSearch = (event) => {
    const value = event?.target?.value;
    setSearch(value);
  };
  const debouncedSearch = debounce(onSearch, 1000);

  useEffect(() => {
    handlePaginationData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handlePaginationData = (page = 1) => {
    getTrailCalender({
      variables: {
        pageNumber: page,
        pageSize: 10,
        search,
        role: role,
        authId: id,
      },
    });
  };

  const renderTableBody = () => {
    return TrailCalenderList.map((user) => (
      <tr key={user.name}>
        <td className={tableDataCls}>{user.name}</td>
        <td className={tableDataCls}>
          {moment(user.date).format(DEFAULT_DATE_FORMAT)}
        </td>
        <td className={tableDataCls}>{user.location}</td>
        <td className={tableDataCls}>
          {[...new Set(user.level.split(", ").map(s => s.trim()))].join(", ")}
        </td>
        <td className={tableDataCls}>{user.noOfEntries}</td>
        <td
          className={`${tableDataCls} ${
            user?.status === "Open"
              ? "text-green font-semibold"
              : user?.status === "Close"
              ? "text-red font-semibold"
              : ""
          }`}
        >
          {user?.status === "Close" ? "Closed" : user?.status}
        </td>
      </tr>
    ));
  };

  return (
    <div className="mt-4">
      <div className="flex flex-col flex-1 md:hidden">
        <span className="text-xl font-bold text-gray-900 px-4 pb-4">
          {globalVariables.trials}
        </span>
        <TrailListMobileHost
          data={TrailCalenderList}
          currentPage={TrailCalenderData?.getTrialCalendarByAuthId?.pageNumber}
          loading={trailCalenderLoading}
          handlePageChange={(page) => handlePaginationData(page)}
          totalPages={TrailCalenderData?.getTrialCalendarByAuthId?.totalPages}
        />
      </div>
      <div className="hidden md:block">
        <TableWithPagination
          isHeaderComponentRow={true}
          headerComponent={
            <SearchBar
              onChange={debouncedSearch}
              placeholder={globalVariables.search}
            />
          }
          totalPage={TrailCalenderData?.getTrialCalendarByAuthId?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          headData={headData}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          tableHeight="h-[45rem]"
          loading={trailCalenderLoading}
          title={globalVariables.trials}
        />
      </div>
    </div>
  );
};

export default HostCalender;
